import React, { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Layout from '../../../layout/Layout';
import { permissions } from '../../../common/permissionGroup';
import AccessDenied from '../../../components/AccessDenied/AccessDenied';
import PermissionsGate from '../../../components/PermissionsGate/PermissionsGate';
import UsersTable from './components/UsersTable';
import Card from '../../../components/Card/Card';
import getUsers from '../../../thunks/users/getUsers';
import UsersSkeleton from './UsersSkeleton';

const containerClassName = 'flex w-full';
const cardBodyClassName = 'px-[30px] py-0';

const Users = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { getUsers: { users, loading } = {} } = useSelector((state) => ({
    getUsers: state?.getUsers
  }), shallowEqual);

  useEffect(() => {
    if (!users.length && !loading) {
      dispatch(getUsers());
    }
  }, []);
  const breadcrumbs = {
    pageTitle: 'Users',
    history: [
      {
        title: 'Home',
        onClick: () => navigate('/')
      },
      {
        title: 'User management',
      },
      {
        title: 'Users',
      }
    ]
  };
  return (
    <Layout breadcrumbs={breadcrumbs}>
      {loading && !users.length ? <UsersSkeleton />
        : (
          <PermissionsGate can={permissions.USERS_READ} errorComponent={<AccessDenied />}>
            <div className={containerClassName}>
              <Card
                showHeader
                headerBordered={false}
                headerTitle="Users List"
                styleBodyContainer={cardBodyClassName}
              >
                <UsersTable users={users} />
              </Card>
            </div>
          </PermissionsGate>
        )}
    </Layout>
  );
};

Users.propTypes = {};

Users.defaultProps = {};

export default Users;
